/* eslint-disable prefer-destructuring,react/destructuring-assignment,react/no-array-index-key */

import React from 'react';
import Immutable from 'immutable';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { FontAwesome } from '../../../components/FontAwesome';
import { PortalQualificationPropType } from '../../../../CustomPropTypes/PortalPropTypes';

class _QualificationTraits extends React.Component {
  static propTypes = {
    qualification: PortalQualificationPropType.isRequired,
    t: PropTypes.func.isRequired,
  };

  getTraits() {
    const { qualification, t } = this.props;
    const certifiedByTemplate = qualification.get('certifiedByTemplate');
    const recognisedTemplate = qualification.get('recognisedTemplate');
    const priceTemplate = qualification.get('priceTemplate');
    const studyModeTemplate = qualification.get('studyModeTemplate');
    const durationTemplate = qualification.get('durationTemplate');
    const startDateTemplate = qualification.get('startDateTemplate');

    let startDateContent = startDateTemplate.get('content');
    const startMonth = startDateContent.split(' ')?.[1];
    if (startMonth) {
      const translatedStartDateContent = startDateContent.replace(
        startMonth,
        t(`date:${startMonth}`)
      );
      startDateContent = translatedStartDateContent;
    }

    const traits = [
      {
        title: t('landingPages:price').toUpperCase(),
        icon: 'tag',
        content: priceTemplate.get('content'),
      },
      {
        title: t('landingPages:certified_by').toUpperCase(),
        icon: 'graduation-cap',
        content: certifiedByTemplate.get('content'),
      },
      {
        title: t('recognised_by').toUpperCase(),
        icon: 'certificate',
        content: recognisedTemplate.get('content'),
      },
      {
        title: t('landingPages:study_mode').toUpperCase(),
        icon: 'laptop',
        content: studyModeTemplate.get('content'),
      },
      {
        title: t('landingPages:duration').toUpperCase(),
        icon: 'clock-o',
        content: durationTemplate.get('content'),
      },
      {
        title: t('landingPages:start_date').toUpperCase(),
        icon: 'calendar',
        content: startDateContent,
      },
    ];

    return Immutable.fromJS(traits);
  }

  render() {
    const traits = this.getTraits();

    return (
      <div className="qualification-traits">
        {traits.map((qualificationTrait, i) => (
          <div key={i} className="qualification-trait">
            <div className="qualification-trait-text-heading">
              {qualificationTrait
                .get('title')
                .split('\n')
                .map((line, j) => (
                  <div key={j}>{line}</div>
                ))}
            </div>
            <div className="qualification-trait-icon">
              <FontAwesome name={qualificationTrait.get('icon')} />
            </div>
            <div className="qualification-trait-text">
              {qualificationTrait
                .get('content')
                .split('\n')
                .map((line, j) => (
                  <div key={j}>{line}</div>
                ))}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export const QualificationTraits = withTranslation(['landingPages', 'date'])(
  _QualificationTraits
);
